<script setup lang="ts">
import { useMediaQueries } from '@nxtpeople/nxt-styles';
const { md } = useMediaQueries();
</script>

<template>
   <div class="board-index" :class="{ '-md': md }">
      <RouterView></RouterView>
   </div>
</template>

<style lang="scss" scoped>
.board-index {
   width: 100%;
   height: 100%;
   overflow: hidden;

   &.-md {
      overflow: unset;
   }
}
</style>
